import { useEffect } from 'react';

/**
 * Close something (a user menu, a popover) on a mousedown outside `ref`.
 *
 * The listener is attached only while `active`; the handler is called on any
 * mousedown whose target lies outside the referenced element. This is the
 * header user-menu behaviour (P-INV-017), shared by the v1 and v2 headers.
 */
export default function useDismiss(ref, onDismiss, active = true) {
    useEffect(() => {
        if (!active) return undefined;
        const handle = (e) => {
            if (ref.current && !ref.current.contains(e.target)) onDismiss();
        };
        document.addEventListener('mousedown', handle);
        return () => document.removeEventListener('mousedown', handle);
    }, [ref, onDismiss, active]);
}
